import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const StudentOldQuestion = ({question, teachername, studentname}) => {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
      <div className="timeline-block">
        <span className="timeline-step badge-white bg-gradient-primary">
          <i className="fa fa-question"></i>
        </span>
        <div className="timeline-content">
          <h6 className="text-muted font-weight-bold questionFont">
            <span className='tittleColor31'>Question</span>
          </h6>
          <h6 className="  ">
            <span className='tittleColor31 studenT3'>
              {question[0].tittle}
            </span>
          </h6>
          <h6 className=" mt-4 mb-0 qAnsw">
          <span className='studenT2'>
            {question[0].description}
            </span>
            </h6>
          <p className=" text-sm mt-1 mb-0">
            by <span style={{ textTransform: 'capitalize' }}> {studentname}  </span>
            at {formatDate(question[0].createdAt)}
          </p>
          <div className="mt-3">
            <LinkContainer to={`/studentwatchquestion/${question[0]._id}`} className='btn btn-primary'>
              <Button variant="primary offset-xl-2 bg-gradient-primary border border-0 rounded-pill"> Watch Question </Button>
            </LinkContainer>    
          </div>
        </div>                           
      </div>

      <div className="timeline-block">
        <span className="timeline-step badge-white bg-gradient-warning ">
          <i className="ni ni-check-bold"></i>
        </span>
        <div className="timeline-content">
          <h6 className="text-muted font-weight-bold questionFont">                            
            <span className='tittleColor224 '>Answer</span>
          </h6>
          <h6 className=" mt-3 mb-0 qAnsw">
          <span className='studenT2'>
            {question[1].description}
          </span>
            </h6>
          <p className=" text-sm mt-1 mb-0">
            by <span style={{ textTransform: 'capitalize' }}> {teachername} </span>
            at  {formatDate(question[1].createdAt)}</p>
          <div className="mt-3">
            <LinkContainer to={`/studentwatchnew/${question[1]._id}`} className='btn btn-default bg-gradient-warning'>
              <Button variant="primary offset-xl-2 border border-0 rounded-pill">&nbsp; Watch  Answer &nbsp; </Button>
            </LinkContainer> 
          </div>
        </div>   
      </div>        
    </div>
  )
}

export default StudentOldQuestion
